import { render, staticRenderFns } from "./Personal_forget.vue?vue&type=template&id=0def1594&scoped=true&"
import script from "./Personal_forget.vue?vue&type=script&lang=js&"
export * from "./Personal_forget.vue?vue&type=script&lang=js&"
import style0 from "./Personal_forget.vue?vue&type=style&index=0&id=0def1594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0def1594",
  null
  
)

export default component.exports